import { useState } from "react";
import { NavBarLinks } from "../../constants";
import { NavBarLinksKids } from "../../constants/NavBarLinks";
import { Link } from "react-router-dom";
import AnimateClose from "./AnimateClose";
import "./Style/Style.css";
import "./NavBar.css";
const NavBarPhone = (props) => {
  const handleClose = () => {
    props.setToggle(!props.toggle);
  };

  const [kids, setKids] = useState(false);

  return (
    <nav className="md:hidden w-full h-full bg-[var(--purple-dark)] fixed">
      <div
        className="absolute w-[14vw] h-[14vw] top-0 right-0"
        onClick={handleClose}
      >
        <AnimateClose />
      </div>

      <div
        style={{
          fontFamily: "Geologica_bold",
          fontSize: "2.5vw",
          color: "var(--purple-white)",
          position: "fixed",
          marginLeft: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        User-friendly menu
        <input
          type="checkbox"
          id="switchPhone"
          onInput={() => {
            setKids(!kids);
          }}
        />
        <label for="switchPhone">Toggle</label>
      </div>
      <ul
        className="flex flex-col items-center justify-center h-full mt-[2rem]"
        style={{ overflow: "auto", maxHeight: "90vh" }}
      >
        {(kids ? NavBarLinksKids : NavBarLinks).map((link) => {
          return link.subsection.map((n) => {
            return (
              <li key={n.section} className="flex mb-0">
                <Link
                  style={{
                    fontFamily: "Geologica_bold",
                    fontSize: "3.3vh",
                    color: "var(--purple-white)",
                    lineHeight: "1.75rem",
                  }}
                  to={`/${n.url}`}
                >
                  {n.section}{" "}
                </Link>
              </li>
            );
          });
        })}
      </ul>
    </nav>
  );
};

export default NavBarPhone;
